export const mainCardData = [
  {
    label: '场域概况',
    value:  1,
    pageId: 2569
  },
  {
    label: '百亿补贴',
    value:  2,
    pageId: 1473
  },
  {
    label: '秒杀',
    value:  3,
    pageId: 2380
  },
  {
    label: '便宜包邮',
    value:  4,
    pageId: 1440
  },
  // {
  //   label: '大促',
  //   value:  5,
  //   pageId: 1,
  //   disabled: true
  // },
  // {
  //   label: '三超',
  //   value:  6,
  //   pageId: 1,
  //   disabled: true
  // },
  // {
  //   label: '互动',
  //   value:  7,
  //   pageId: 1,
  //   disabled: true
  // },
  {
    label: '新品',
    value:  8,
    pageId: 2620
  },
  {
    label: 'PLUS',
    value:  9,
    pageId: 2345
  },
  {
    label: '排行榜',
    value:  10,
    pageId: 1116
  },
  {
    label: '搜索',
    value:  11,
    pageId: 3902
  },
  {
    label: '推荐',
    value:  12,
    pageId: 5799
  },
  {
    label: '黄流',
    value:  13,
    pageId: 867
  },
  {
    label: '活动',
    value:  14,
    pageId: 0
  },
];

export const mainCardMap = new Map([
  [1,  {
    label: '场域概况',
    value:  1,
    pageId: '2569'
  }],
  [2,  {
    label: '百亿补贴',
    value:  2,
    pageId: '1473'
  }],
  [3,  {
    label: '秒杀',
    value:  3,
    pageId: '2380',
    subCard:     {
      label: '数据总览',
      value: 1
    },
    // {
    //   label: '综合诊断',
    //   value: 2,
    //   disabled: true
    // },
  }],
  [4, {
    label: '便宜包邮',
    value:  4,
    pageId: '1440'
  }],
  // [5, {
  //   label: '大促',
  //   value:  5,
  //   pageId: 1,
  //   disabled: true
  // }],
  // [6,{
  //   label: '三超',
  //   value:  6,
  //   pageId: 1,
  //   disabled: true
  // }],
  // [7,{
  //   label: '互动',
  //   value:  7,
  //   pageId: 1,
  //   disabled: true
  // }],
  [8,{
    label: '新品',
    value:  8,
    pageId: '2620'
  }],
  [9,{
    label: 'PLUS',
    value:  9,
    pageId: '2345'
  }],
  [10,{
    label: '排行榜',
    value:  10,
    pageId: '1116'
  }],
  [11, {
    label: '搜索',
    value:  11,
    pageId: '3902'
  }],
  [12, {
    label: '推荐',
    value:  12,
    pageId: '5799'
  }],
  [13,{
    label: '黄流',
    value:  13,
    pageId: '867'
  }],
  [14,{
    label: '活动',
    value:  14,
    pageId: '0'
  }],
])